<template lang="pug">
<span>{{formatted}}</span>
</template>

<script>
import Moment from 'moment'
export default {
  props: {
    dateTime: String,
    locale: String,
  },
  computed: {
    formatted() {
      Moment.locale(this.locale)
      // Moment.locale(window.navigator.userLanguage || window.navigator.lenguage)
      return Moment(this.dateTime).format('LLL')
    }
  }
}
</script>